export const TAB_KEYS = {
  COLUMNS: "COLUMNS",
  ROWS: "ROWS",
  GRADING_PERIODS: "GRADING_PERIODS",
};

export const GRADE_SCALE_VIEW_TYPES = {
  GRADING_PERIOD_WISE: "GRADING_PERIOD_WISE",
  ACROSS_GRADING_PERIODS: "ACROSS_GRADING_PERIODS",
};

export const GRADING_PERIOD_COLUMNS_SECTION_ID = "grading_period_columns";

export const SECTION_ID_TO_CONFIG_KEY = {
  general_columns: "general",
  grading_period_columns: "gradeScales",
  grading_period_aggregates_for_row: "columnAggregates",
};

export const ITEM_ID_TO_CONFIG_ID = {
  subject_course: "COURSE_NAME",
  subject_course_id: "COURSE_ID",
  levels: "LEVEL",
  overall_credits: "OVERALL_CREDITS",
};

export const ROW_SECTION_ID_TO_CONFIG_KEY = {
  grading_period_aggregates: "rowAggregates",
  year_level_aggregates: "yearAggregates",
  across_year_aggregates: "acrossYearAggregates",
};
export const ROW_SECTION_IDS_WITH_HEADER_CHECKBOX = [
  "grading_period_aggregates",
  "year_level_aggregates",
  "across_year_aggregates",
];
export const ROW_SECTION_IDS_WITHOUT_CHILDREN = [
  "year_level_aggregates",
  "across_year_aggregates",
];

export const ROW_ITEM_KEYS = {
  TOTAL: "TOTAL",
  AVERAGE: "AVERAGE",
  GPA: "GPA",
};

export const GRADE_SCALE_TYPES_IN_ORDER = [
  "OVERALL_SCORE",
  "OVERALL_GRADE",
  "CREDITS",
  "LOCAL_GRADE",
];

export const GRADE_SCALE_TYPES = {
  DEPENDENT: "DEPENDENT",
  SPECIAL: "SPECIAL",
  REGULAR: "REGULAR",
};

export const GRADE_SCALE_TYPE_LOCALE_MAP = {
  [GRADE_SCALE_TYPES.REGULAR]: "common:regular_grade_scale",
  [GRADE_SCALE_TYPES.SPECIAL]: "academicSetup:special_codes_grade_scale",
  [GRADE_SCALE_TYPES.DEPENDENT]: "common:dependent_grade_scale",
};

export const ROW_CHILD_ID_TO_GRADE_SCALE_TYPE = {
  score: "OVERALL_SCORE",
  grade: "OVERALL_GRADE",
  credits: "CREDITS",
  gpa: "LOCAL_GRADE",
  local_grade: "LOCAL_GRADE",
  overall_score: "OVERALL_SCORE",
  overall_grade: "OVERALL_GRADE",
  final_score: "FINAL_SCORE",
  final_grade: "FINAL_GRADE",
  credit: "CREDIT",
};

export const SECTION_NODE_KEY = "SECTION_NODE_KEY";
export const GRADE_WISE_NODE_KEY = "GRADE_WISE_NODE_KEY";
export const DEFAULT_COLUMNS_ROWS_KEY = "DEFAULT_COLUMNS_ROWS_KEY";
export const ACROSS_YEAR_AGGREGATES_KEY = "ACROSS_YEAR_AGGREGATES_KEY";
export const GRADING_PERIODS_SETTINGS_KEY = "GRADING_PERIODS_SETTINGS_KEY";
export const GRADE_OPTION_KEY_PREFIX = "GRADE_OPTION_KEY_";

export const AGGREGATE_TYPE_DESCRIPTION_MAP = {
  CGPA: "transcript:aggregate_cgpa_across_all_grading_periods",
  TOTAL: "transcript:aggregate_sum_across_grading_periods",
  AVERAGE: "transcript:aggregate_mean_across_grading_periods",
};

export const APPLY_OPTION_KEYS = {
  APPLY_FOR_THIS_STUDENT: "apply_for_this_student",
  APPLY_FOR_MULTIPLE_STUDENTS: "apply_for_multiple_students",
};
